import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetCourseProgress, GetCoursePaymentDetails } from "../../Actions/CourseA";
import CoursesProgresReport from "../../Components/CourseProgressReport/CoursesProgresReport";
import useCheckLogin from "../../Helpers/CustomHooks/CheckLogin";
import MyCourses from "../../Components/MyCourses/MyCourses";
import { EnrolledCourseButtonsInfo } from "../../PageNames";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import PaymentImage from "./Assets/paypalPaymentimg.png";
import CreditCard from "./Assets/CreditCardMethod.svg";
import GooglePay from "./Assets/GooglePayMethod.png";
import ApplePay from "./Assets/ApplePayMethod.png";
import BankTransfer from "./Assets/BankTransferMethod.svg";
import Visa from "./Assets/visa.svg";
import mastercard from "./Assets/mastercard.svg";
import americanexpress from "./Assets/americanexpress.svg";
import UnknownCardImage from "./Assets/unknown.svg";
import { useNavigate } from "react-router-dom";
import { GetLocalStorage } from "../../Helpers/LocalStorage/LocalStorage";

const PaymentDetails = () => {
  const Dispatch = useDispatch();
  const { EnrollmentId } = useParams();
  const navigate = useNavigate();

  const { coursePaymentDetailsData } = useSelector(
    (Store) => Store.CourseReducer
  );

  const UserId = GetLocalStorage("UserInfo")?.UserId;
  console.log("UserId in PaypalBtn is:",UserId)

  console.log("coursePaymentDetailsData in PaymentDetails is:",coursePaymentDetailsData)

  useEffect(() => {
      Dispatch(GetCoursePaymentDetails(EnrollmentId, UserId));
  }, [Dispatch, EnrollmentId]);

  const Package = coursePaymentDetailsData?.Package || {};
  const Installments = coursePaymentDetailsData?.Installments || [];
  const Payments = coursePaymentDetailsData?.Payments || [];
  const CourseName = coursePaymentDetailsData?.courseName || "";

    // Extract total fee
    const totalFee = Package?.TotalFee || 0;

    // Calculate total paid amount
    const totalPaid = Payments?.reduce((sum, payment) => sum + payment.AmountPaid, 0) || 0;

    const amountPaidWithTax = Payments?.reduce((sum, payment) => sum + payment.AmountPaidWithTax, 0) || 0;

    // Calculate remaining balance
    const remainingBalance = totalFee - totalPaid;

    // Calculate percentage paid
    const percentagePaid = (totalPaid / totalFee) * 100;

    // Find next pending installment
    const nextInstallment = Installments && Installments.length > 0 
    ? Installments.find(inst => inst.Status === "Pending") 
    : null;

    // Count total and paid installments
    const totalInstallments = Installments?.length || 0;
    const paidInstallments = Installments?.filter(inst => inst.Status === "Paid").length || 0;
    const remainingInstallments = totalInstallments - paidInstallments;

    const getInstallmentText = (schedule) => {
        const mapping = {
          Weekly: "week",
          Monthly: "month",
          Quarterly: "quarter",
        };
      
        return mapping[schedule] || "period"; // Fallback in case of an unexpected value
      };      
      const Border = "border-[#E2E2E2] border-[1px] border-solid";

      const maskedEmail = (email) => {
        if (!email) return "";
        const parts = email.split("@");
        return parts[0].substring(0, 3) + "***@" + parts[1]; 
    };
    
    const maskedCardNumber = (cardNumber) => {
        if (!cardNumber) return "";
        return "**** **** **** " + cardNumber.slice(-4);
    };
    
    const paymentsData = coursePaymentDetailsData?.Payments?.map((payment, index) => {
        // Match payment with installment
        const installment = coursePaymentDetailsData?.Installments?.find(
            (inst) => inst.InstallmentId === payment.InstallmentFK
        );
    
        // Find payment method
        const paymentMethod = coursePaymentDetailsData?.PaymentMethods?.find(
            (method) => method.PaymentMethodId === payment.PaymentMethodFK
        );
    
        let paymentMethodDisplay = "";
        let paymentMethodImage = "";

        if (paymentMethod?.PaymentType === "paypal") {
            paymentMethodDisplay = maskedEmail(paymentMethod?.PaypalEmail);
            paymentMethodImage=PaymentImage;
        } else if (paymentMethod?.PaymentType === "googlepay") {
            paymentMethodDisplay = maskedEmail(paymentMethod?.GooglePayEmail);
            paymentMethodImage=GooglePay;
        } else if (paymentMethod?.PaymentType === "applepay") {
            paymentMethodDisplay = maskedEmail(paymentMethod?.ApplePayEmail);
            paymentMethodImage=ApplePay;
        } else if (paymentMethod?.PaymentType === "creditCard") {
            paymentMethodDisplay = maskedCardNumber(paymentMethod?.CreditCardNumber);

            // Now check the brand
            const brand = paymentMethod?.CreditCardBrand?.toLowerCase();  // Example: "visa", "mastercard", "amex"

            if (brand === "visa") {
                paymentMethodImage = Visa;
            } else if (brand === "mastercard") {
                paymentMethodImage = mastercard;
            } else if (brand === "amex" || brand === "american express") {
                paymentMethodImage = americanexpress;
            } else {
                paymentMethodImage = UnknownCardImage; // fallback image if brand not matched
            }
            
            // paymentMethodImage=CreditCard;
        }  else if (paymentMethod?.PaymentType === "BankAccount") {
            paymentMethodDisplay = maskedCardNumber(paymentMethod?.BankAccountNumber);
            paymentMethodImage=BankTransfer;
        }
    
        return {
            id: (index + 1).toString().padStart(2, "0"), // Format ID as "01", "02", etc.
            package: coursePaymentDetailsData?.courseName,
            packageName: coursePaymentDetailsData?.Package?.Name,
            installments: coursePaymentDetailsData?.Installments?.length > 1 
                ? `${coursePaymentDetailsData?.Installments?.length} Installments`
                : "None",
            paymentType: installment ? `Installments | ${installment?.InstallmentNumber}` : "One Time Pay",
            paymentMethod: paymentMethodDisplay,
            paymentMethodImgs:paymentMethodImage,
            date: new Date(payment?.PaymentDate).toLocaleDateString(),
            paymentId: payment?.PaymentId, // Fix: Use 'payment' instead of 'Payments'
            amount: `$${payment?.AmountPaidWithTax.toFixed(2)}`,
            invoice: "View",
        };
    });

    const handleClick = (paymentId) => {
        navigate(`/enrolledcourse/paymentdetails/invoice/${paymentId}`);
      };          

  return (
    <MyCourses ButtonsInfo={EnrolledCourseButtonsInfo} Param={EnrollmentId} PageName="PaymentDetails" DisplayName={CourseName}>
      <div className="w-full flex justify-center items-center mt-[50px]">
            <div className="w-[80%] flex flex-col gap-[20px]">
                <div className="w-full bg-[#FFFFFF] rounded-[14px] shadow-[4px_5px_6px_#00000029] p-[20px]"
                    style={{
                        border:"1px solid #B9B9B9"
                    }}>
                    <p className="text-[22px] text-[#4D4F5C] text-center lg:text-left">Package Details</p>
                    <p className="text-[31px] text-[#000000] lg:text-[#4D4F5C] text-bold mt-[10px] text-center lg:text-left">{Package?.Name || "N/A"}</p>
                    <div className="w-full flex justify-center items-center lg:justify-end">
                        <p className="text-[44px] text-[#4D4F5C]">${totalFee.toFixed(2)} <sup className="text-[18px] ml-[-10px]">+Tax</sup></p>
                    </div>
                </div>

                <p className="text-[30px] text-[#4C34AD] font-bold text-center lg:text-left">Overview</p>

                <div className="flex items-center flex-wrap gap-[25px]">
                    <div className="w-[340px] h-[240px] flex flex-col gap-[20px] bg-[#FFFFFF] rounded-[14px] shadow-[4px_5px_6px_#00000029] px-[25px] py-[20px]"
                    style={{
                        border:"1px solid #B9B9B9"
                    }}>
                        <p className="text-[22px] text-[#4D4F5C] text-center lg:text-left">Total Amount To pay</p>
                        <p className="text-[44px] text-[#4D4F5C] text-center lg:text-left">${remainingBalance.toFixed(2)} <sup className="text-[18px] ml-[-10px]">+Tax</sup></p>
                        <div className="w-full h-[10px] rounded-[6px] overflow-hidden"
                            style={{
                            border:"1px solid #B9B9B9"
                        }}>
                            <div className="bg-[#955FEC] h-full" style={{ width: `${percentagePaid}%` }}></div>
                        </div>
                        <p className="text-[18px] text-[#4D4F5C] text-center lg:text-left">Amount Paid with Tax ${amountPaidWithTax.toFixed(2)}</p>
                    </div>

                    <div className="w-[340px] h-[240px] flex flex-col gap-[20px] bg-[#FFFFFF] rounded-[14px] shadow-[4px_5px_6px_#00000029] px-[25px] py-[20px]"
                    style={{
                        border:"1px solid #B9B9B9"
                    }}>
                        <p className="text-[22px] text-[#4D4F5C] text-center lg:text-left">Next Installment</p>
                        <p className="text-[44px] text-[#4D4F5C] text-center lg:text-left"> ${nextInstallment?.Amount.toFixed(2) || "0"} <sup className="text-[18px] ml-[-10px]">+Tax</sup></p>
                        <div className="flex flex-col gap-[5px]">
                            <p className="text-[18px] text-[#4D4F5C] text-center lg:text-left">Due date : {nextInstallment ? new Date(nextInstallment.DueDate).toLocaleDateString() : "N/A"}</p>
                            <p className="text-[18px] text-[#4D4F5C] text-center lg:text-left">Amount Due ${remainingBalance.toFixed(2)}<sup className="text-[18px]">+Tax</sup></p>
                        </div>
                    </div>

                    <div className="w-[340px] h-[240px] flex flex-col gap-[20px] bg-[#FFFFFF] rounded-[14px] shadow-[4px_5px_6px_#00000029] px-[25px] py-[20px]"
                    style={{
                        border:"1px solid #B9B9B9"
                    }}>
                        <p className="text-[22px] text-[#4D4F5C] text-center lg:text-left">Installment Remaining</p>
                        <p className="text-[44px] text-[#4D4F5C] text-center lg:text-left">{remainingInstallments} Installment</p>
                        <div className="flex flex-col gap-[5px]">
                        <p className="text-[18px] text-[#4D4F5C] text-center lg:text-left">
                            Total Installment {Package?.InstallmentSchedule && ` per ${getInstallmentText(Package.InstallmentSchedule)}`} : {totalInstallments} 
                        </p>
                            <p className="text-[18px] text-[#4D4F5C] text-center lg:text-left">Paid Installment : {paidInstallments}</p>
                        </div>
                    </div>
                </div>
                
                <div className="mt-[30px] w-full bg-[#FFFFFF] rounded-[14px] shadow-[4px_5px_6px_#00000029] py-[20px] overflow-x-auto"
                    style={{
                            border:"1px solid #B9B9B9"
                        }}>
                    <table className="w-full border-collapse ">
                        <thead>
                            <tr className="bg-[#4C34AD] px-5 text-white h-[50px]">
                                <th className="text-[18px] text-center  hidden lg:table-cell">S.No</th>
                                <th className="text-[18px] text-center  hidden lg:table-cell">Package</th>
                                <th className="text-[18px] text-center  hidden lg:table-cell">Installment</th>
                                <th className="text-[18px] text-center  hidden lg:table-cell">Payment type</th>
                                <th className="text-[18px] text-center  hidden lg:table-cell">Payment Method</th>
                                <th className="text-[18px] text-center">Payment Date</th>
                                <th className="text-[18px] text-center">Amount</th>
                                <th className="text-[18px] text-center">Invoice</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                        {/* {[
                            {
                            id: "01",
                            package: "Automotive Course",
                            packageName:"Gold",
                            installments: "None",
                            paymentType: "One Time Pay",
                            paymentMethod: "**** **** **** 6789",
                            date: "07/09/2022",
                            amount: "$2000.00",
                            invoice: "View",
                            },
                            {
                            id: "02",
                            package: "Automotive Course",
                            packageName:"Gold",
                            installments: "3 Installments",
                            paymentType: "Installments | 2",
                            paymentMethod: "**** **** **** 6789",
                            date: "07/09/2022",
                            amount: "$250.00",
                            invoice: "View",
                            },
                        ].map((row, index) => (
                            <tr key={index} className={`py-5 ${
                                index % 2 === 1 ? "bg-[#F6F6F6] ${Border}" : ""
                                }`}>
                            <td className="text-[17px] text-[#174A84] text-center">{row.id}</td>
                            <td className="text-[17px] text-[#174A84] text-center flex flex-col items-center pb-3">
                            <p 
                                className="w-40 truncate overflow-hidden whitespace-nowrap text-ellipsis"
                                title={row.package} // Tooltip to show full text on hover
                            >
                                {row.package}
                            </p>
                                <p>{row.packageName}</p>
                            </td>
                            <td className="text-[17px] text-[#174A84] text-center">{row.installments}</td>
                            <td className="text-[17px] text-[#174A84] text-center">{row.paymentType}</td>
                            <td className="text-[17px] text-[#174A84] text-center flex flex-col items-center">
                                <img src={PaymentImage} alt="PayPal" className="h-[30px]" />
                                {row.paymentMethod}
                            </td>
                            <td className="text-[17px] text-[#174A84] text-center">{row.date}</td>
                            <td className="text-[17px] text-[#174A84] text-center">{row.amount}</td>
                            <td className="cursor-pointer flex pt-6"><p className="pt-[10px]"><RemoveRedEyeIcon sx={{ color: "#174A84" }}/></p>
                            <p className="text-[17px] text-[#174A84] text-center pt-[10px]">{row.invoice}</p></td>
                            </tr>
                        ))} */}
                        {paymentsData?.map((row, index) => (
                            <tr key={index} className={`lg:py-5 ${index % 2 === 1 ? "bg-[#F6F6F6] ${Border}" : ""}`}>
                                <td className="text-[17px] text-[#174A84] text-center  hidden lg:table-cell">{row.id}</td>
                                <td className="text-[17px] text-[#174A84] text-center lg:flex flex-col items-center pb-3 hidden">
                                    <p className="w-40 truncate overflow-hidden whitespace-nowrap text-ellipsis" title={row.package}>
                                        {row.package}
                                    </p>
                                    <p>{row.packageName}</p>
                                </td>
                                <td className="text-[17px] text-[#174A84] text-center  hidden lg:table-cell">{row.installments}</td>
                                <td className="text-[17px] text-[#174A84] text-center  hidden lg:table-cell">{row.paymentType}</td>
                                <td className="text-[17px] text-[#174A84] text-center lg:flex flex-col gap-[10px] items-center hidden">
                                    <img src={row.paymentMethodImgs} alt="PayPal" className="h-[30px]" />
                                    {row.paymentMethod}
                                </td>
                                <td className="text-[17px] text-[#174A84] text-center py-[20px] lg:py-0">{row.date}</td>
                                <td className="text-[17px] text-[#174A84] text-center py-[20px] lg:py-0">{row.amount}</td>
                                <td className="cursor-pointer flex py-[20px] lg:py-0 lg:pt-6"
                                onClick={() => handleClick(row.paymentId)}>
                                    <p className=" pt-[5px] lg:pt-[10px]"><RemoveRedEyeIcon sx={{ color: "#174A84" }}/></p>
                                    <p className="text-[17px] text-[#174A84] text-center pt-[5px] lg:pt-[10px]">{row.invoice}</p>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

            </div>
      </div>
    </MyCourses>
  );
};

export default PaymentDetails;